module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-258.ba91b9ba.svg";